import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSkolkovo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 102 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#C1D944" d="M0 0h102v55H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.097 10.919h-5.023v2.37S25.127 10 19.588 10C14.048 10 10 12.438 10 16.951c0 4.514 3.075 6.388 9.588 7.942 6.403 1.529 6.402 2.38 6.4 3.723v.07c0 1.383-1.407 3.113-5.657 3.113s-5.512-4.515-5.512-4.515-1.98.076-4.819 0c.86 6.78 5.473 8.584 10.331 8.71 4.858.125 7.209-2.096 7.209-2.096v1.453h4.557v-6.174l2.28-1.893 4.588 8.077H45l-6.778-11.343 5.88-6.55h-5.88l-6.125 6.55v-13.1Zm-7.642 6.846h2.84v5.146c-.789-1.025-3.943-1.76-6.761-2.415-1.075-.25-2.102-.49-2.93-.728-2.995-.867-2.74-2.96-2.74-2.96s.575-2.708 4.7-2.708c4.123 0 4.89 3.665 4.89 3.665Z"
      fill="#616366"
    />
    <path
      d="M11.45 47.12c.95 0 1.39-.51 1.81-1.3l2.91-5.49h-.95l-2.09 4.13-2.09-4.13h-.95l2.56 4.87-.12.23c-.37.69-.59.95-1.12.95-.37 0-.67-.2-.91-.45l-.35.66c.24.3.74.53 1.3.53Zm6.151-4.95h-.75v1.59c0 1.1.53 1.59 1.79 1.59.55 0 1.11-.14 1.47-.32V47h.75v-4.83h-.75v2.25c-.29.15-.78.26-1.28.26-.8 0-1.23-.25-1.23-1.15v-1.36Zm7.78 4.83h.75v-3.32c0-1.17-.85-1.63-1.87-1.63-.79 0-1.41.26-1.93.8l.35.52c.43-.46.9-.67 1.48-.67.7 0 1.22.37 1.22 1.02v.87c-.39-.45-.94-.66-1.6-.66-.82 0-1.69.51-1.69 1.59 0 1.05.87 1.6 1.69 1.6.65 0 1.2-.23 1.6-.67V47Zm-1.33-.42c-.7 0-1.19-.44-1.19-1.05 0-.62.49-1.06 1.19-1.06.53 0 1.04.2 1.33.6v.91c-.29.4-.8.6-1.33.6Zm5.714.54c.88 0 1.4-.36 1.77-.84l-.5-.46c-.32.43-.73.63-1.23.63-1.03 0-1.67-.8-1.67-1.87s.64-1.86 1.67-1.86c.5 0 .91.19 1.23.63l.5-.46c-.37-.48-.89-.84-1.77-.84-1.44 0-2.41 1.1-2.41 2.53 0 1.44.97 2.54 2.41 2.54Zm3.7-.12h.75v-4.17h1.41v-.66h-3.56v.66h1.4V47Zm3.144 0h.75v-2.16h2.52V47h.75v-4.83h-.75v2.01h-2.52v-2.01h-.75V47Zm5.518 0h.72l2.55-3.76V47h.75v-4.83h-.74l-2.53 3.69v-3.69h-.75V47Zm8.807 0h.96l-2.15-2.64 2.14-2.19h-.95l-2.54 2.57v-2.57h-.75V47h.75v-1.38l.8-.79 1.74 2.17Z"
      fill="#616366"
    />
  </svg>
);
const Memo = memo(SvgSkolkovo);
export default Memo;
